import { useContentResource } from "@ctv/core";
import {
  InfoBox,
  InputDropdownRHF,
  InputRHF,
  Text,
  Token,
} from "@ctv/shared-core/src";
import { Fragment } from "react";
import { StyleSheet } from "react-native";
import { POSITIONS } from "../../../_constants";
import { FieldRow } from "../../FieldRow";

export default function InformationDirectorAttorney() {
  const { CorporateRegistration: cr, CorporateRegistrationDropdown: crd } =
    useContentResource();

  const positionDropdownItems = POSITIONS.map((position) => ({
    label: crd[position],
    value: position,
  }));
  return (
    <Fragment>
      <Text style={styles.marginBottomM} variant="title-1">
        {cr.directorAttorneyTitle}
      </Text>
      <InfoBox
        style={styles.marginBottomM}
        title={cr.directorAttorneyInfoBoxTitle}
        children={
          <Text ink="highlight" variant="ui-small">
            {cr.directorAttorneyInfoBoxContent}
          </Text>
        }
      />
      <FieldRow
        style={styles.marginBottomM}
        label={cr.directorAttorneyFullNameLabel}
        required
      >
        <InputRHF
          name="ownerName"
          onBlur={(value, onChange) => onChange(value.trim())}
          style={styles.flex1}
        />
      </FieldRow>
      <FieldRow label={cr.directorAttorneyPositionLabel} required>
        <InputDropdownRHF
          name="ownerJobTitle"
          style={styles.flex1}
          items={positionDropdownItems}
          editable
          searchable
          labelAsInputValue
        />
      </FieldRow>
    </Fragment>
  );
}

const styles = StyleSheet.create({
  // General styles
  marginBottomM: {
    marginBottom: Token.spacing.m,
  },
  flex1: {
    flex: 1,
  },
});
